import originalAxios from "axios";

// Get API URL from environment variables
export const apiUrl =
  process.env.REACT_APP_API_URL || "http://localhost:4000/api";

originalAxios.defaults.baseURL = apiUrl;

export const axios = originalAxios;
